export const useExtractResponseMessage = (t: any, resp: any) => {

    let response = resp;
    if('response' in resp) {
        response = resp.response;
    }
    else if('message' in resp) {
        return resp.message;
    }

    let message;
    if (typeof response.data === 'string' || response.data instanceof String) {
        message = response.data;
    }
    else if(Array.isArray(response.data)) {
        message = response.data.map((msg: any) => msg).join(' ');
    }
    else if(typeof response.data === "object") { 
        if('message' in response.data) {
            message = response.data.message;
        }
        else {
            message = Object.entries(response.data)[0].map((entry: any) => entry).join(': ');
        }
    }

    if(response.status >= 400) {
        console.error("error", { ...response }, message);
        message = t("common:error.defaultMessage") 
    }
    else {
        message = message.length === 0 ? t("common:success.defaultMessage") : message
    }

    return message;
};

export const isEpochTime = (date: any)  => {
    return date instanceof Date && date.getTime() === 0;
}